import React from 'react';
import award from '../Assets/award.svg';
import style from '../../src/Components/Students/Profilev0.3.1/StudentProfile.module.css';
import { badges } from './contants';
import { useSelector } from 'react-redux';

const Badges = ({ data }) => {
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
      {data?.map((item) => (
        <div className={style.badgeswithIcon}>
          <img src={award} alt='award' />
          <div className={style.text}>&nbsp;{badges[item]}</div>
        </div>
      ))}
    </div>
  );
};

export default Badges;
